import secureLocalStorage from 'react-secure-storage';
import { io } from 'socket.io-client';
import { addMessage, editMessage, readMessages, sendMessage, deleteMessage } from './slices/chatSlice';
import { decryptMessage, encryptMessage } from '../crypto/cryptoMessage';

let socket = null;
let currentIdentifier = null; 
const SOCKET_URL = process.env.REACT_APP_CHAT_SERVICE_WS;
const platform_url = process.env.REACT_APP_CHAT_PLATFORM_URL;

export const connectChatWebSocket = ({ platform_id }) => ({
  type: 'chat/ws/connect',
  payload: { platform_id }
});

export const chatWsMiddleware = store => next => action => {
  if (action.type === 'chat/ws/connect') {
    const { platform_id } = action.payload;
    const token = secureLocalStorage.getItem('token');
    const newIdentifier = JSON.stringify({ platform_id });

    if (socket && socket.connected && currentIdentifier === newIdentifier) {
      console.log('[WS] already connected with same identifier');
      return next(action);
    }

    if (socket) {
      socket.disconnect();
      socket = null;
    }

    currentIdentifier = newIdentifier;
    socket = io(SOCKET_URL, {
      transports: ['websocket'],
      query: { identifier: platform_id, user_type: 'lead' },
      auth: { token }
    });

    socket.on('connect', () => {
      console.log('[WS] connected:', socket.id);
    });

    socket.on('disconnect', reason => {
      console.log('[WS] disconnected:', reason);
    });

    socket.on('connect_error', err => {
      console.error('[WS] connection error:', err);
    });

    socket.once('status', () => {
      socket.emit('register', { account_id: secureLocalStorage.getItem('selected_account')?.Id, platform_url });
    });

    socket.on('message', async (payload) => {
      const msg = await JSON.parse(decryptMessage(payload.msg))
      store.dispatch(addMessage({ msg }));
      if (store.getState().chat.chatIsOpen) {
        store.dispatch(readMessages());
      }
    });

    socket.on('edit',async (payload) => {
      const msg = await JSON.parse(decryptMessage(payload.msg))
      store.dispatch(editMessage({ msg }));
    });

    socket.on('delete', async (payload) => {
      const { id, decrement } = await JSON.parse(decryptMessage(payload.msg))
      store.dispatch(deleteMessage({ id, decrement }));
    });
  }

  if (action.type === sendMessage.type && socket) {
    const { msg } = action.payload;
    const payload = encryptMessage(JSON.stringify({ msg}));
    socket.emit('message', payload);
  }

  if (action.type === readMessages.type && socket) {
    socket.emit('readMessage');
  }

  return next(action);
};
